// src/hooks/usePacketName.ts
import { useEffect, useState } from "react";
import { useNotesStore } from "../state/notes-store";
import { listPackets, getCurrentPacketId } from "../persistence/packets";

export function usePacketName() {
  const { currentPacketId } = useNotesStore();
  const [packetName, setPacketName] = useState<string>("");

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const id = currentPacketId || (await getCurrentPacketId());
        if (!id) { on && setPacketName(""); return; }
        const packets = await listPackets();
        const found = packets.find((p) => p?.id === id);
        on && setPacketName(found?.name || "");
      } catch {
        on && setPacketName("");
      }
    })();
    return () => { on = false; };
  }, [currentPacketId]);

  return { packetName };
}
